import React from 'react';
import { sanitize } from 'dompurify';
import { useTranslation } from 'react-i18next';
import { Accordion } from '../Accordion/Accordion';
import {
  AccordionDisclaimer,
  AccordionIngredientsList,
  AccordionIngredientsWrapper,
} from './ProductDetails.styles';
import { splitIngredients } from '../../utils/products';

type ProductDetailsAccordionProps = {
  details: string | null;
  ingredients: string | null;
};

export const ProductDetailsAccordion = ({ details, ingredients }: ProductDetailsAccordionProps) => {
  const { t } = useTranslation(['components']);

  const splittedIngredients = splitIngredients(ingredients);

  const detailsItem = {
    header: t('details'),
    body: (
      <span
        className="pb-3 d-block"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: sanitize(details || ''), // details can be null
        }}
      />
    ),
  };

  const ingredientsItem = {
    header: t('ingredients'),
    body: (
      <AccordionIngredientsWrapper>
        <AccordionIngredientsList>
          {splittedIngredients?.map((ingredient, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={`${ingredient}-${idx}`}>{ingredient}</li>
          ))}
        </AccordionIngredientsList>
        <AccordionDisclaimer>{t('ingredientsDisclaimer')}</AccordionDisclaimer>
      </AccordionIngredientsWrapper>
    ),
  };

  const accordionItems = [
    ...(details ? [detailsItem] : []),
    ...(ingredients?.length ? [ingredientsItem] : []),
  ];

  return <Accordion items={accordionItems} />;
};
